export default __webpack_public_path__ + "static/media/undraw_High_five_u364.d795827d.svg";